jQuery(document).ready(function ($) {

function getFilterCountByPrefix(prefix = 'gf_') {
  const params = new URLSearchParams(window.location.search);
  let count = 0;
  for (const [key, value] of params.entries()) {
    if (key.startsWith(prefix) && value !== '') {
      count++;
    }
  }
  return count;
}

const selectedFilterCount = getFilterCountByPrefix();

if (selectedFilterCount >= 1) {
  $(".product-grid-container").addClass("show-item");
} else {
  $(".product-grid-container").removeClass("show-item");
}


$(document).on("click", "a.btn.button.button--primary.find_right_product", function () {
  //$(".product-grid-container").addClass("show-item");
    const modelCheckedCount = $('.model-custom .gf-option-box li a.checked').length;
    if (modelCheckedCount > 0) {
      $(".model-required-msg").hide();
      $(".product-grid-container").addClass("show-item");
    } else {
      $(".model-required-msg").show();
      $(".product-grid-container").removeClass("show-item");
  }
  $('.gf-close-canvas').trigger('click');
    if ($(window).width() < 768) {
      $('.gf-actions').attr('tabindex', '-1').focus();
      $('html, body').animate({
        scrollTop: $('.gf-actions').offset().top - 100
      }, 500);
    }


});


   $(document).on("click", ".type_of_vehicle li.list-menu__item.facets__item", function () {
        $(".type_of_vehicle li input[type='checkbox']").prop("checked", false);
        $(this).addClass("active");
        $(this).find("input[type='checkbox']").prop("checked", true);
       const text = $(this).find('.facet-checkbox__text-label').text()
            .toLowerCase()
            .trim()
            .replace(/\s+/g, '-');

          if (text) {
            $('.vehicle_planner_slider').hide();
            $('.slider-' + text).show();
          }

   });

   // qty //
  $(document).on("click", ".qty-plus, .qty-minus", function () {
    const input = $(this).siblings(".qty-input");
    const isPlus = $(this).hasClass("qty-plus");
    let currentQty = parseInt(input.val());

    if (isNaN(currentQty)) currentQty = 0;

    if (isPlus) {
      input.val(currentQty + 1); // Increase quantity
    } else {
      if (currentQty > 0) {
        input.val(currentQty - 1); // Decrease quantity, but not below 0
      }
    }

      // Update the subtotal for the specific product
      const product = $(this).closest(".grid__item");
      updateSubtotal(product);
    });

    // Update subtotal for a single product item
    function updateSubtotal(product) {
      const qty = parseInt(product.find(".qty-input").val());
      const price = parseFloat(product.data("price"));
      const subtotal = qty * price;

      if (qty > 0) {
        product.find(".subtotal-value").text(subtotal.toFixed(2)); // Show formatted subtotal
        product.find(".subtotal").show(); // Show subtotal section
      } else {
        product.find(".subtotal").hide(); // Hide if quantity is 0
      }

      updateTotalSubtotal(); // Recalculate total
    }

    // Calculate and update the total subtotal for all visible products
    function updateTotalSubtotal() {
      let total = 0;
      $(".product-item:visible").each(function () {
        const qty = parseInt($(this).find(".qty-input").val());
        const price = parseFloat($(this).data("price"));
        if (!isNaN(qty) && !isNaN(price)) {
          total += qty * price;
        }
      });

      $("#total-subtotal").text(formatMoney(total)); // Update total value

      if (total > 0) {
        $(".subtotal-box").show(); // Show total section
      } else {
        $(".subtotal-box").hide(); // Hide if total is 0
      }
    }
  //Thanh added formatmoney function . and ,
  function formatMoney(number, decPlaces, decSep, thouSep) {
      decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
      decSep = typeof decSep === "undefined" ? "," : decSep;
      thouSep = typeof thouSep === "undefined" ? "." : thouSep;
      const sign = number < 0 ? "-" : "";
      const i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
      const j = (i.length) > 3 ? i.length % 3 : 0;

      return sign +
          (j ? i.substr(0, j) + thouSep : "") +
          i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
          (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
  }

  $(".add-to-cart").on("click", function () {
    const items = [];
    $(".product-item:visible").each(function () {
      const id = $(this).data("id");
      const qty = $(this).find(".qty-input").val();
      items.push({ id: id, quantity: parseInt(qty) });
      });

    if (items.length > 0) {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: JSON.stringify({ items: items }), // FIX: Correct JSON format
        contentType: "application/json", // FIX: Set correct content type
        dataType: "json",
        success: function () {
          window.location.href = (window.routes && window.routes.cart_url) || "/cart"; // Redirect to cart after adding (keeps the shopper's language)
           $(document).trigger("cart:refresh");

        },
        error: function (err) {
          console.error("Cart Error:", err);
        }
      });
    } else {

    }
  });



});